import { camelToSnakeCase } from "@centivo-business/utils/src/conversionUtils"
import _ from "lodash";
import HrpDate from "./HrpDate";

const SimpleTable = ({ columns, rows, disableHeaderFormatting, onClickHandler, selectedIndex }) => {
    if (!columns?.length || !rows?.length) return
    return <div className="table-wrapper" style={{ minHeight: 'fit-content' }}>
        <table>
            <thead>
                <tr>
                    {columns?.map((key) => (
                        <th key={key?.attribute}>{disableHeaderFormatting ? key.label : camelToSnakeCase(key.label)}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows?.map((row, i) => {
                    // A row can carry multiple version-expiration dates from joined tables
                    // (versionExpDateKey, versionExpDateKey1, versionExpDateKey2, ...).
                    // Treat the row as expired if ANY of them is in the past. Long.MIN
                    // (-9223372036854776000) is a "not set" sentinel from HRP and is ignored.
                    const now = Date.now();
                    const hasVersionExpired = row
                        ? Object.keys(row).some(key =>
                            /^versionExpDateKey\d*$/.test(key) &&
                            typeof row[key] === 'number' &&
                            row[key] > 0 &&
                            row[key] < now
                        )
                        : false;
                    return <tr key={`row-${i}`} style={{ backgroundColor: hasVersionExpired ? "var(--lightRed)" : "" }} >

                        {columns.map((header, j) => {
                            const value = _.get(row, header.attribute);
                            // Auto-render Date keys (e.g. versionEffDateKey, versionExpDateKey3)
                            // as human-readable dates via HrpDate.
                            const isDateKey = /DateKey\d*$/.test(header?.attribute || '');
                            return (
                                <td key={`${i}-${j}-${header?.attribute}`} style={{
                                    backgroundColor: selectedIndex == i ? 'var(--lightGreen)' : '',
                                    padding: '10px',
                                    border: '1px solid #ccc',
                                    whiteSpace: 'nowrap'
                                }}
                                    onClick={() => onClickHandler?.({ ...row, _index: i })}
                                >
                                    {isDateKey && (value || value === 0)
                                        ? <HrpDate dateKey={value} />
                                        : value?.toString()}
                                </td>
                            );
                        })}
                    </tr>
                }
                )}
            </tbody>
        </table>
    </div>

}
export default SimpleTable